import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import horizontallyCenteredSection from '../../../components/styles/horizontallyCenteredSection';
import Pixel3DBox from '../../../components/Svg/Home/Pixel3DBox';
import Pixel3DPrinter from '../../../components/Svg/Home/Pixel3DPrinter';
import PixelBracer from '../../../components/Svg/Home/PixelBracer';
import PixelMachine from '../../../components/Svg/Home/PixelMachine';
import PixelMouse from '../../../components/Svg/Home/PixelMouse';
import backgroundImage from './images/highlightsBg.png';

const HighlightsContainer = styled.section`
  ${horizontallyCenteredSection}
  padding-top: 5rem;
  padding-bottom: 5rem;
  background-color: var(--color-grey-1);
  background-image: url('${backgroundImage}');
  background-position: center;
`;

const Highlight = styled.article`
  padding: 2.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: var(--color-grey-1);

  svg {
    max-width: 4rem;
    margin-bottom: 2.5rem;
  }

  h3,
  p {
    margin: 0 0 2rem 0;
  }

  &:not(:last-of-type) {
    margin-bottom: 2.5rem;
  }

  @media (min-width: 768px) {
    min-height: 44vh;
    padding: 3%;

    svg {
      max-width: 7vh;
      margin-bottom: 3vh;
    }

    && h3,
    && p {
      margin: 0 0 3vh 0;
    }

    &:not(:last-of-type) {
      margin-bottom: 3vh;
    }
  }
`;

function Highlights() {
  const intl = useIntl();

  return (
    <HighlightsContainer>
      <Highlight>
        <PixelMachine />
        <h3>{intl.formatMessage({ id: 'home_highlight_components_title' })}</h3>
        <p>{intl.formatMessage({ id: 'home_highlight_components_text' })}</p>
      </Highlight>
      <Highlight>
        <PixelMouse />
        <h3>
          {intl.formatMessage({ id: 'home_highlight_performance_title' })}
        </h3>
        <p>{intl.formatMessage({ id: 'home_highlight_performance_text' })}</p>
      </Highlight>
      <Highlight>
        <Pixel3DPrinter />
        <h3>{intl.formatMessage({ id: 'home_highlight_3d_title' })}</h3>
        <p>{intl.formatMessage({ id: 'home_highlight_3d_text' })}</p>
      </Highlight>
      <Highlight>
        <Pixel3DBox />
        <h3>{intl.formatMessage({ id: 'home_highlight_craft_title' })}</h3>
        <p>{intl.formatMessage({ id: 'home_highlight_craft_text' })}</p>
      </Highlight>
      <Highlight>
        <PixelBracer />
        <h3>{intl.formatMessage({ id: 'home_highlight_tested_title' })}</h3>
        <p>{intl.formatMessage({ id: 'home_highlight_tested_text' })}</p>
      </Highlight>
    </HighlightsContainer>
  );
}

export default Highlights;
